// extracted by mini-css-extract-plugin
module.exports = {"root":"RangeSlider_root__2YO3U","activeHandle":"RangeSlider_activeHandle__27Tz9"};